(function($, Drupal, once) {
  Drupal.behaviors.teaserSelector = {
    attach: function(context) {
      once(
          'teaser-selector',
          '.paragraph--type--teaser-selector .wrapper .teaser-selector-container .right-column',
          context,
      ).forEach(function(container) {
        $(container).
            find('.teaser-selector__navigation a').
            on('click', function(e) {
              e.preventDefault();
              if (!$('.paragraph--type--teaser-selector').hasClass('active')) {
                $('.paragraph--type--teaser-selector').addClass('active');
              }

              $('.paragraph--type--teaser-selector .wrapper .teaser-selector-container .right-column .teaser-selector__navigation a').removeClass('active');
              $(this).addClass('active');

              const index = $(this).data('index');

              $('.paragraph--type--teaser-selector .wrapper .teaser-selector-container .teaser-selector__content .teaser-content').removeClass('active');
              $(`.paragraph--type--teaser-selector .wrapper .teaser-selector-container .teaser-selector__content .teaser-content[data-index="${index}"]`).addClass('active');
            });
      });

      const teaserSelectorSlider = once('teaser-selector', '#teaser_selector_slider', context);
      teaserSelectorSlider.forEach((sliderElement) => {

        const teaserSplideSlider = new Splide(sliderElement, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          padding: {
            right: '35%',
          },
          trimSpace: false,
          gap: '12px',
          autoplay: false,
          arrows: false,
          label: 'Before/After slider',
          labelledby: 'Before/After slider',
          role: 'banner',
          draggable: true,
          pagination: true
        });

        teaserSplideSlider.mount();
      });
    },
  };
})(jQuery, Drupal, once);